import { useGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { blogPostRecordQuery } from "@/app/Blogs/GraphQL/blogPostRecordQuery";
import { blogPostRoute } from "@/app/Blogs/Routes/blogRoutes";
import { RecordScreenCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenCard";
import { BlogTranslationsPanel } from "@/app/Blogs/Components/BlogTranslationsPanel";

export function BlogPostTranslationsScreen() {
  const { id } = blogPostRoute.useParams();
  const { data } = useGqlQuery(blogPostRecordQuery, { id });

  const post = data?.blogPost;

  if (!post) {
    return <div className="p-6 text-zinc-500">Post not found.</div>;
  }

  return (
    <div className="space-y-12 py-6">
      <RecordScreenCard title="Translations">
        <BlogTranslationsPanel post={post} />
      </RecordScreenCard>
    </div>
  );
}
